import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../core/i18n';
import { TrackedOrderDelivery, TrackedOrderStatus } from '../../../core/model';
import { NotificationModule } from '../notification';

@Component({
  selector: 'py-delivery-timeline',
  templateUrl: './delivery-timeline.component.html',
  styleUrls: ['./delivery-timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, I18nModule, NzIconModule, NotificationModule],
})
export class DeliveryTimelineComponent {
  @Input() delivery: TrackedOrderDelivery;
  @Input() showTrackingLinks: boolean = true;

  constructor(private windowRef: WindowRef) {}

  get isDeliveryUnknown(): boolean {
    return !this.delivery;
  }

  get hasOrderProcessingStarted(): boolean {
    const status = this.delivery?.overallPickingStatus;
    return status != null && status !== TrackedOrderStatus.NOT_STARTED;
  }

  get isOrderProcessingComplete(): boolean {
    return this.delivery?.overallPickingStatus === TrackedOrderStatus.COMPLETED;
  }

  get hasTransitStarted(): boolean {
    const transitStatus = this.delivery?.transitStatus;
    const totalGoodsMovementStatus = this.delivery?.totalGoodsMovementStatus;
    if (transitStatus == null && totalGoodsMovementStatus == null) {
      return false;
    }
    return transitStatus
      ? transitStatus !== TrackedOrderStatus.NOT_STARTED
      : totalGoodsMovementStatus !== TrackedOrderStatus.NOT_STARTED;
  }

  get isTransitComplete(): boolean {
    return this.delivery?.transitStatus
      ? this.delivery?.transitStatus === TrackedOrderStatus.COMPLETED
      : this.delivery?.totalGoodsMovementStatus === TrackedOrderStatus.COMPLETED;
  }

  get hasDeliveryStarted(): boolean {
    const deliveryStatus = this.delivery?.deliveryStatus;
    const billingStatus = this.delivery?.billingStatus;

    if (deliveryStatus == null && billingStatus == null) {
      return false;
    }
    return deliveryStatus ? deliveryStatus !== TrackedOrderStatus.NOT_STARTED : billingStatus !== TrackedOrderStatus.NOT_STARTED;
  }

  get isDeliveryComplete(): boolean {
    return this.delivery?.deliveryStatus === TrackedOrderStatus.COMPLETED;
  }

  navigateToExternalTrackingPage(url: string): void {
    if (this.windowRef.isBrowser()) {
      this.windowRef.nativeWindow.open(url, '_blank');
    }
  }
}
